import { useState } from "react";
import { useTranslation } from "react-i18next";
import { I18nKey } from "../../../i18n/i18n";
import { Button } from "../../common/Button";
import { DeleteModal } from "../../common/DeleteModal";
import { Modal, ModalActions } from "../../common/Modal";

/**
 * Suppression d'un élevage ou d'un bâtiment, qui ne part que vide : tant qu'il ne l'est pas
 * (`blockedText` renseigné), la fenêtre explique quoi retirer au lieu de proposer la
 * suppression. L'API refuse de toute façon un élément non vide.
 */
export const DeleteEmptyModal = ({
  isOpen,
  onClose,
  title,
  warningText,
  blockedText,
  onDelete,
  onDeleted,
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  warningText: string;
  blockedText: string;
  onDelete: () => Promise<I18nKey | "">;
  onDeleted: () => void;
}) => {
  const { t } = useTranslation();
  const [error, setError] = useState<I18nKey | "">("");
  const [deleting, setDeleting] = useState(false);

  const close = () => {
    setError("");
    onClose();
  };

  const confirm = async () => {
    setDeleting(true);
    const result = await onDelete();
    setDeleting(false);
    if (result) {
      setError(result);
      return;
    }
    setError("");
    onDeleted();
  };

  if (blockedText) {
    return (
      <Modal isOpen={isOpen} onClose={close} title={title} maxWidth="md">
        <div className="space-y-4 py-4">
          <p className="text-default-text">{blockedText}</p>
          <ModalActions>
            <Button onClick={close}>{t("button-close")}</Button>
          </ModalActions>
        </div>
      </Modal>
    );
  }

  return (
    <DeleteModal
      title={title}
      warningText={warningText}
      isOpen={isOpen}
      onClose={close}
      handleConfirmDelete={confirm}
      error={error ? t(error) : ""}
      loading={deleting}
    />
  );
};
